module.exports = "https://cdn.hellotech.com/client-assets/soundbar_install_25383000b664474337f542c9d5220cb1.png";